// extracted by mini-css-extract-plugin
export default {"container":"notification-provider_container__4scK6","notification":"notification-provider_notification__haU0J"};